import {
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";

const ResultadosMangasPublicadas = ({ modalState, closeModal, mangas }) => {
  return (
    <React.Fragment>
      <Modal open={modalState} onClose={closeModal} className="ModalC">
        <Paper sx={{ p: "10%" }}>
          <Typography className="Titulo" sx={{ textAlign: "center", mb: "5%" }}>
            Detalle de Mangas
          </Typography>
          <Table>
            <TableHead
              sx={{}}
              style={{
                width: "100%",
                alignContent: "center",
                alignSelf: "center",
                height: "auto",
              }}
            >
              <TableRow>
                {Array.from(new Array(mangas.length)).map((e, i) => (
                  <TableCell key={i + 1}>
                    <Typography variant="body1" className="Titulo">
                      {"T" + (i + 1)}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody
              sx={{}}
              style={{
                width: "98%",
                alignContent: "center",
                alignSelf: "center",
                height: "auto",
              }}
            >
              <TableRow>
                {mangas &&
                  mangas.map((manga) => <TableCell>{manga}</TableCell>)}
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
      </Modal>
    </React.Fragment>
  );
};

export default ResultadosMangasPublicadas;
